import React from 'react';
import Settings from '../components/Settings/Settings';

export const SettingsPage: React.FC = () => {
  return <Settings />;
};
